import useGlobalRoutesHandler from "@/hooks/useGlobalHandleRouter";
import DefaultSidebar from "./components/DefaultSidebar";
import AgentSideBar from "./components/AgentSideBar";

const SidebarLayout = () => {
  const { activeRoutes } = useGlobalRoutesHandler();

  if (activeRoutes.includes("agent")) {
    return <AgentSideBar />;
  }

  return <DefaultSidebar />;
};

export default SidebarLayout;
